import { Radio, RadioProps } from "@mui/material";
import { RadioButtonFilledIcon, RadioButtonIcon } from "./Icons";

const GKRadio = (
  props: RadioProps & {
    disableLeftPadding?: boolean;
    disableRightPadding?: boolean;
    disableTopPadding?: boolean;
    disableBottomPadding?: boolean;
    padding?: number | string;
  },
) => {
  const {
    disableLeftPadding,
    padding,
    disableBottomPadding,
    disableTopPadding,
    disableRightPadding,
    sx,
    ...rest
  } = props;
  return (
    <Radio
      {...rest}
      sx={{
        ...sx,
        paddingLeft: disableLeftPadding ? 0 : padding,
        paddingRight: disableRightPadding ? 0 : padding,
        paddingTop: disableTopPadding ? 0 : padding,
        paddingBottom: disableBottomPadding ? 0 : padding,
      }}
      icon={
        <RadioButtonIcon width={22} height={22} color={"var(--grey-300)"} />
      }
      checkedIcon={
        <RadioButtonFilledIcon
          width={22}
          height={22}
          color={"var(--primary-900)"}
        />
      }
    />
  );
};

export default GKRadio;
